import type { PropType } from 'virtual-vue';

/**
 * 组件的props
 */
export const props = {
  /**
   * 是否开启左右内边距
   * @default true
   */
  padded: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  /**
   * 单元格组标题
   */
  title: {
    type: [String] as PropType<string>,
    default: '',
  },
};
